import { useFormikContext } from "formik";
import { titleCase } from "../../CommonFuntion/SchemaValidation";

const CatalogueOutTableLabelField = (props) => {
  const { name, label, tagName, validation = {} } = props;
  const { values } = useFormikContext();
  const id = `${tagName}-label`;

  return (
    <div className="flex-container">
      <div className="control-bottom-border">
        {label && (
          <label className="font-css" htmlFor={id}>
            {titleCase(label.replace("_", " "))}
            {validation?.mandatory && (
              <span  className="mandatory-validation">{"*"}</span>
            )}
          </label>
        )}
      </div>
      <div className="control-bottom-border">
        <span style={{
                  fontSize: "12px",
                }} id={id} data-testid="CatalogueOutTableLabelField">
          {values?.[name] ?? ""}
        </span>
      </div>
    </div>
  );
};

export default CatalogueOutTableLabelField;
